import { useTranslation } from 'react-i18next';
import { arEG,enUS } from '@mui/material/locale';

const LANGS = [

  {

    label: 'Arabic',
    value: 'ar',
    systemValue: arEG,
    icon: '/static/icons/sa.svg'

  },
  {

    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/sh.svg'

  },

];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
